import { auth } from './auth';

const redirectToJoin = (): void => {
    auth.signup();
};

export default redirectToJoin;
